import _ from 'lodash'
import React from 'react'
import { AsyncTypeahead } from 'react-bootstrap-typeahead'
import { Field, reduxForm } from 'redux-form'
import { Link } from 'react-router-dom'

import Pagination from './Pagination'
import Sort from './Sort'

class DefectList extends React.Component {
  render () {
    const {
      list, listDefects, getPdf, query, order, handleSubmit, submitting, reset, projects, onProjectChanged,
      mainAreas, onMainAreaChanged, defectAreas, searchUser, setUserSelected, assignee, clearUserKey,
    } = this.props
    if (!list) return (<div/>)
    const { limit, page, count, rows } = list
    const defectRows = rows.map(row => (
      <tr key={row.id}>
        <td><span className="tx-14">{row.project ? row.project.name : ''}</span></td>
        <td><span className="tx-14">{row.defectArea && row.mainArea ? row.mainArea.name : ''}</span></td>
        <td><span className="tx-14">{row.defectArea ? row.defectArea.name : ''}</span></td>
        <td><span className="tx-14">{row.detail}</span></td>
        <td style={{maxWidth: '200px'}}>
            {
                row.defectImages[0] &&
          <div className="card">
                  <a href={row.defectImages[0].imageUrl} target="_blank">
                    <img src={row.defectImages[0].imageUrl} alt="" width="100%"/>
                  </a>
          </div>
            }
            {
                row.defectImages[1] &&
                <div className="card">
                  <a href={row.defectImages[1].imageUrl} target="_blank">
                    <img src={row.defectImages[1].imageUrl} alt="" width="100%"/>
                  </a>
                </div>
            }
        </td>
        <td><span className="tx-14">{row.assigneeUser ? row.assigneeUser.name : ''}</span></td>
        <td><span className="tx-14">{row.expectedDeliveryDate ? new Date(row.expectedDeliveryDate).toLocaleDateString(): ''}</span></td>
        <td className="text-center"><Link title="แก้ไขข้อบกพร่อง" className="btn-icon-custom text-center mg-sm-b-10 mg-lg-b-0" to={`/defect/${row.id}/edit`}>
          <i className="icon ion-gear-b tx-primary tx-20"></i>
        </Link></td>
      </tr>
    ))
    const pagination = count !== 0 ?
      <Pagination limit={limit} page={page} count={count} query={query}
                  onPageClick={listDefects}/> : undefined
    const projectOptions = projects ? _.map(projects, (project) => (
      <option key={project.id} value={project.id}>{project.name}</option>
    )) : undefined
    const mainAreaOptions = mainAreas ? _.map(mainAreas, (mainArea) => (
      <option key={mainArea.id} value={mainArea.id}>{mainArea.name}</option>
    )) : undefined
    const defectAreaOptions = defectAreas ? _.map(defectAreas, (defectArea) => (
      <option key={defectArea.id} value={defectArea.id}>{defectArea.name}</option>
    )) : undefined
    const  selectedAssignee = assignee.selected ? assignee.selected[0] : undefined
    return (
      <div>
        <div className="pd-x-20 pd-sm-x-30 pd-t-20 pd-sm-t-30">
          <div className="float-right float-btn">
            <Link to={'/defect/add'} className="btn btn-primary">แจ้งข้อบกพร่อง</Link>
          </div>
          <h4 className="tx-gray-800 mg-b-5">ข้อบกพร่อง</h4>
        </div>
        <div className="br-pagebody">
          <div className="br-section-wrapper">
            <div className="row">
              <div className="col-lg-12">
                <div className="form-layout form-layout-2">
                  <form className="row no-gutters"
                        onSubmit={handleSubmit((values) => {
                          listDefects(values, selectedAssignee)
                        })}>
                    <div className="col-lg-2 mg-t--1 mg-md-t-0">
                      <div className="form-group">
                        <label htmlFor="projectId" className="form-control-label">โครงการ :</label>
                        <Field name="projectId" component="select" className="form-control select2"
                               onChange={onProjectChanged}>
                          <option/>
                          {projectOptions}
                        </Field>
                      </div>
                    </div>
                    <div className="col-lg-2 mg-t--1 mg-md-t-0">
                      <div className="form-group mg-md-l--1">
                        <label htmlFor="main-area" className="form-control-label">พื้นที่หลัก :</label>
                        <Field name="mainAreaId" component="select" className="form-control select2"
                               onChange={onMainAreaChanged}>
                          <option/>
                          {mainAreaOptions}
                        </Field>
                      </div>
                    </div>
                    <div className="col-lg-2 mg-t--1 mg-md-t-0">
                      <div className="form-group mg-md-l--1">
                        <label htmlFor="defect-area" className="form-control-label">บริเวณที่เกิดข้อบกพร่อง :</label>
                        <Field name="defectAreaId" component="select" className="form-control select2">
                          <option/>
                          {defectAreaOptions}
                        </Field>
                      </div>
                    </div>
                    <div className="col-lg-2 mg-t--1 mg-md-t-0">
                      <div className="form-group mg-md-l--1">
                        <label htmlFor="assignee" className="form-control-label">มอบหมายให้ :</label>
                        <AsyncTypeahead
                          ref={(ref) => this.assigneeRef = ref}
                          multiple={false} minLength={1} labelKey="name" placeholder="ค้นหาผู้ที่ถูกมอบหมาย..."
                          isLoading={assignee.isLoading || false} options={assignee.list ? assignee.list.rows : []}
                          onSearch={(query) => searchUser(query, 'assignee')}
                          onChange={(selected) => setUserSelected(selected, 'assignee')}/>
                      </div>
                    </div>
                    <div className="col-lg-2 mg-t--1 mg-md-t-0">
                      <div className="form-group mg-md-l--1">
                        <label htmlFor="status" className="form-control-label">สถานะ :</label>
                        <Field name="status" component="select" className="form-control">
                          <option/>
                          <option>OPEN</option>
                          <option>ACCEPT</option>
                          <option>INPROGRESS</option>
                          <option>DONE</option>
                          <option>CLOSE</option>
                          <option>REOPEN</option>
                        </Field>
                      </div>
                    </div>
                    <div className="col-lg-2 mg-t--1 mg-md-t-0">
                      <div className="form-group from-inline form-check mg-md-l--1">
                        <label className="form-control-label">&nbsp;</label>
                        <label htmlFor="isDelayed" className="">
                          <Field name="isDelayed" component="input" type="checkbox" className=""/>
                          <span className="mg-l-10">งานที่เกินกำหนด</span>
                        </label>
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="form-layout-footer bd pd-20 bd-t-0">
                        <button type="submit" className="btn btn-primary mg-r-10" disabled={submitting}>ค้นหา</button>
                        <button type="button" className="btn btn-outline-primary mg-r-10" disabled={submitting} onClick={() => {
                          reset()
                          this.assigneeRef.getInstance().clear()
                          clearUserKey()
                          listDefects()
                        }}>ยกเลิก
                        </button>
												<button type="submit" className="btn btn-outline-primary" disabled={submitting} onClick={handleSubmit((values) => {
													getPdf(values, selectedAssignee)
												})} >นำออกเป็น PDF
												</button>
                      </div>
                    </div>
                  </form>
                </div>
                <br/>
                <div className="">
                  <div className="table-responsive mg-b-20">
                    <table className="table table-bordered table-colored table-dark">
                      <thead className="thread-light thead-colored thead-primary">
                      <tr>
                        <th className="text-center" scope="col" onClick={() => listDefects(query, selectedAssignee, 'projectName')}>
                          <span className="tx-13">โครงการ</span> <Sort name="projectName" order={order}/>
                        </th>
                        <th className="text-center" scope="col" onClick={() => listDefects(query, selectedAssignee, 'mainAreaName')}>
                          <span className="tx-13">พื้นที่หลัก</span> <Sort name="mainAreaName" order={order}/>
                        </th>
                        <th className="text-center" scope="col" onClick={() => listDefects(query, selectedAssignee, 'defectAreaName')}>
                          <span className="tx-13">บริเวณที่เกิดข้อบกพร่อง</span> <Sort name="defectAreaName" order={order}/>
                        </th>
                        <th className="text-center" scope="col" onClick={() => listDefects(query, selectedAssignee, 'detail')}>
                          <span className="tx-13">รายละเอียด</span> <Sort name="detail" order={order}/>
                        </th>
                        <th className="text-center" scope="col" onClick={() => listDefects(query, selectedAssignee, 'mainAreaName')}>
                          <span className="tx-13">รูปภาพ</span>
                        </th>
                        <th className="text-center" scope="col"><span className="tx-13">มอบหมายให้</span></th>
                        <th className="text-center" scope="col" onClick={() => listDefects(query, selectedAssignee, 'expectedDeliveryDate')}>
                          <span className="tx-13">วันที่คาดว่าจะเสร็จ</span> <Sort name="expectedDeliveryDate" order={order}/>
                        </th>
                        <th className="text-center" scope="col"><span className="tx-13">Action</span></th>
                      </tr>
                      </thead>
                      <tbody>
                      {defectRows}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12 mg-b-20">
                    <div className="row align-items-center justify-content-center">
                      {pagination}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default reduxForm({
  form: 'defect-list'
})(DefectList)



// WEBPACK FOOTER //
// ./src/components/DefectList.js